import { Container } from 'pixi.js';
import { ShockwaveFilter } from '@pixi/filter-shockwave';

interface Shock { filter: ShockwaveFilter; t: number; dur: number; }

// Shockwave manager — fires distortion ripples on bomb / boss-kill / phase-shift impacts.
// Attaches/removes Pixi ShockwaveFilters from the target Container's filter array.
export class Shockwaves {
  private active: Shock[] = [];
  private target: Container;

  constructor(target: Container) {
    this.target = target;
  }

  trigger(x: number, y: number, dur = 1.0, amp = 30, wave = 160): void {
    const f = new ShockwaveFilter(
      [x, y],
      { amplitude: amp, wavelength: wave, brightness: 1.0, speed: 800, radius: -1 },
      0,
    );
    this.active.push({ filter: f, t: 0, dur });
    this.target.filters = this.active.map((s) => s.filter as any);
  }

  tick(dt: number): void {
    if (this.active.length === 0) return;
    let dirty = false;
    for (let i = this.active.length - 1; i >= 0; i--) {
      const s = this.active[i];
      s.t += dt;
      s.filter.time = s.t;
      if (s.t >= s.dur) {
        this.active.splice(i, 1);
        dirty = true;
      }
    }
    if (dirty) {
      this.target.filters = this.active.length > 0
        ? (this.active.map((s) => s.filter as any))
        : ([] as any);
    }
  }
}
